/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Notlist_Piracy1Inputs */

const id_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform untuk pembajakan atau aktivitas ilegal: Kami sangat mengutuk pembajakan dan tidak menyediakan cara apa pun untuk mengakses atau mendistribusikan konten berhak cipta secara ilegal.`)
};

const ms_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform untuk cetak rompak atau aktiviti haram: Kami sangat mengutuk cetak rompak dan tidak menyediakan sebarang cara untuk mengakses atau mengedarkan kandungan berhak cipta secara haram.`)
};

const da_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En platform for piratkopiering eller ulovlige aktiviteter: Vi fordømmer kraftigt piratkopiering og giver ikke nogen midler til at få adgang til eller distribuere ophavsretligt beskyttet indhold ulovligt.`)
};

const de_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Plattform für Piraterie oder illegale Aktivitäten: Wir lehnen Piraterie entschieden ab und bieten keine Mittel, um urheberrechtlich geschütztes Material illegal zu nutzen oder zu verbreiten.`)
};

const en_us2_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A platform for piracy or illegal activities: We strongly condemn piracy and do not provide any means to access or distribute copyrighted content illegally.`)
};

const es_es2_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una plataforma de piratería o actividades ilegales: Condenamos enérgicamente la piratería y no proporcionamos ningún medio para acceder o distribuir contenido protegido por derechos de autor ilegalmente.`)
};

const es_mx2_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una plataforma de piratería o actividades ilegales: Condenamos enérgicamente la piratería y no proporcionamos ningún medio para acceder o distribuir contenido protegido por derechos de autor ilegalmente.`)
};

const fil_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang platform para sa piracy o ilegal na aktibidad: Mahigpit naming kinokondena ang piracy at hindi kami nagbibigay ng anumang paraan upang ma-access o maikalat ang naka-copyright na content nang ilegal.`)
};

const fr_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une plateforme de piratage ou d'activités illégales : Nous condamnons fermement le piratage et ne fournissons aucun moyen d'accéder ou de distribuer du contenu protégé par le droit d'auteur illégalement.`)
};

const it_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una piattaforma per pirateria o attività illegali: Condanniamo fermamente la pirateria e non forniamo alcun mezzo per accedere o distribuire illegalmente contenuti protetti da copyright.`)
};

const hu_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform kalózkodáshoz vagy illegális tevékenységekhez: Határozottan elítéljük a kalózkodást, és nem biztosítunk semmilyen eszközt szerzői joggal védett tartalom illegális eléréséhez vagy terjesztéséhez.`)
};

const nl_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een platform voor piraterij of illegale activiteiten: We veroordelen piraterij ten zeerste en bieden geen middelen om illegaal toegang te krijgen tot auteursrechtelijk beschermd materiaal of dit te verspreiden.`)
};

const no_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En plattform for piratkopiering eller ulovlige aktiviteter: Vi fordømmer piratkopiering på det sterkeste og gir ingen midler til å få tilgang til eller distribuere opphavsrettsbeskyttet innhold ulovlig.`)
};

const pl_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformą do piractwa ani nielegalnych działań: Stanowczo potępiamy piractwo i nie udostępniamy żadnych środków do nielegalnego dostępu do treści chronionych prawem autorskim.`)
};

const pt_br2_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma plataforma para pirataria ou atividades ilegais: Condenamos veementemente a pirataria e não fornecemos quaisquer meios para acessar ou distribuir ilegalmente conteúdo protegido por direitos autorais.`)
};

const pt_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma plataforma de pirataria ou atividades ilegais: Condenamos veementemente a pirataria e não fornecemos qualquer meio de aceder ou distribuir conteúdo protegido por direitos de autor ilegalmente.`)
};

const ro_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O platformă pentru piraterie sau activități ilegale: Condamnăm cu fermitate pirateria și nu oferim niciun mijloc de a accesa sau distribui conținut protejat prin drepturi de autor în mod ilegal.`)
};

const fi_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alusta piratismille tai laittomille toimille: Tuomitsemme jyrkästi piratismin emmekä tarjoa mitään keinoa päästä käsiksi tai levittää tekijänoikeudella suojattua sisältöä laittomasti.`)
};

const sv_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En plattform för piratkopiering eller olaglig verksamhet: Vi fördömer starkt piratkopiering och tillhandahåller inga medel för att olagligt komma åt eller distribuera upphovsrättsskyddat material.`)
};

const vi_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một nền tảng vi phạm bản quyền hoặc hoạt động bất hợp pháp: Chúng tôi lên án mạnh mẽ việc vi phạm bản quyền và không cung cấp bất kỳ phương tiện nào để truy cập hoặc phân phối nội dung có bản quyền một cách bất hợp pháp.`)
};

const tr_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korsanlık veya yasa dışı faaliyetler için bir platform: Korsanlığı şiddetle kınıyor ve telif hakkıyla korunan içeriğe yasa dışı olarak erişmek veya dağıtmak için herhangi bir araç sağlamıyoruz.`)
};

const cs_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforma pro pirátství nebo nelegální aktivity: Důrazně odsuzujeme pirátství a neposkytujeme žádné prostředky k přístupu nebo distribuci nelegálně chráněného obsahu.`)
};

const bg_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа за пиратство или незаконни дейности: Ние категорично осъждаме пиратството и не предоставяме никакви средства за достъп или разпространение на незаконно защитено съдържание.`)
};

const ru_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформой для пиратства или незаконной деятельности: Мы решительно осуждаем пиратство и не предоставляем никаких средств для доступа или распространения незаконно защищённого авторским правом контента.`)
};

const uk_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформою для піратства: Ми рішуче засуджуємо піратство та не надаємо жодних засобів для незаконного доступу або розповсюдження захищеного авторським правом контенту.`)
};

const ar_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منصة للقرصنة أو الأنشطة غير القانونية: ندين بشدة القرصنة ولا نقدم أي وسيلة للوصول إلى المحتوى المحمي بحقوق الطبع والنشر أو توزيعه بشكل غير قانوني.`)
};

const hi_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाइरेसी या अवैध गतिविधियों के लिए एक प्लेटफ़ॉर्म।`)
};

const th_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตฟอร์มสำหรับการละเมิดลิขสิทธิ์หรือกิจกรรมที่ผิดกฎหมาย: เราประณามการละเมิดลิขสิทธิ์อย่างรุนแรงและไม่ได้ให้ช่องทางใด ๆ ในการเข้าถึงหรือแจกจ่ายเนื้อหาที่มีลิขสิทธิ์อย่างผิดกฎหมาย`)
};

const ja_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海賊行為や違法行為のプラットフォーム：私たちは海賊行為を強く非難し、著作権で保護されたコンテンツに違法にアクセスしたり配布したりする手段を一切提供しません。`)
};

const zh_cn2_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`盗版或非法活动的平台：我们强烈谴责盗版行为，不提供任何访问或分发受版权保护内容的途径。`)
};

const zh_hant1_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`盜版或非法活動的平台：我們強烈譴責盜版行為，不提供任何存取或散布受版權保護內容的途徑。`)
};

const ko_privacy_notlist_piracy1 = /** @type {(inputs: Privacy_Notlist_Piracy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`불법 복제 또는 불법 활동을 위한 플랫폼: 불법 복제를 강력히 반대하며 불법적으로 저작권이 있는 콘텐츠에 접근하거나 배포하는 수단을 제공하지 않습니다.`)
};

/**
* | output |
* | --- |
* | "A platform for piracy or illegal activities: We strongly condemn piracy and do not provide any means to access or distribute copyrighted content illegally." |
*
* @param {Privacy_Notlist_Piracy1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_notlist_piracy1 = /** @type {((inputs?: Privacy_Notlist_Piracy1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Notlist_Piracy1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_notlist_piracy1(inputs)
	if (locale === "ms") return ms_privacy_notlist_piracy1(inputs)
	if (locale === "da") return da_privacy_notlist_piracy1(inputs)
	if (locale === "de") return de_privacy_notlist_piracy1(inputs)
	if (locale === "en-US") return en_us2_privacy_notlist_piracy1(inputs)
	if (locale === "es-ES") return es_es2_privacy_notlist_piracy1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_notlist_piracy1(inputs)
	if (locale === "fil") return fil_privacy_notlist_piracy1(inputs)
	if (locale === "fr") return fr_privacy_notlist_piracy1(inputs)
	if (locale === "it") return it_privacy_notlist_piracy1(inputs)
	if (locale === "hu") return hu_privacy_notlist_piracy1(inputs)
	if (locale === "nl") return nl_privacy_notlist_piracy1(inputs)
	if (locale === "no") return no_privacy_notlist_piracy1(inputs)
	if (locale === "pl") return pl_privacy_notlist_piracy1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_notlist_piracy1(inputs)
	if (locale === "pt") return pt_privacy_notlist_piracy1(inputs)
	if (locale === "ro") return ro_privacy_notlist_piracy1(inputs)
	if (locale === "fi") return fi_privacy_notlist_piracy1(inputs)
	if (locale === "sv") return sv_privacy_notlist_piracy1(inputs)
	if (locale === "vi") return vi_privacy_notlist_piracy1(inputs)
	if (locale === "tr") return tr_privacy_notlist_piracy1(inputs)
	if (locale === "cs") return cs_privacy_notlist_piracy1(inputs)
	if (locale === "bg") return bg_privacy_notlist_piracy1(inputs)
	if (locale === "ru") return ru_privacy_notlist_piracy1(inputs)
	if (locale === "uk") return uk_privacy_notlist_piracy1(inputs)
	if (locale === "ar") return ar_privacy_notlist_piracy1(inputs)
	if (locale === "hi") return hi_privacy_notlist_piracy1(inputs)
	if (locale === "th") return th_privacy_notlist_piracy1(inputs)
	if (locale === "ja") return ja_privacy_notlist_piracy1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_notlist_piracy1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_notlist_piracy1(inputs)
	return ko_privacy_notlist_piracy1(inputs)
});
export { privacy_notlist_piracy1 as "privacy.notList.piracy" }